import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { times } from 'lib/utils';
import Dot from './Dot';

export enum Sizes {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLOListElement>, HTMLOListElement> {
  count: number;
  currentSlide: number;
}

const TRANSITION_TIME = '400ms';

function ListDot({ dot }: { dot: Dot }): JSX.Element {
  return (
    <li
      className={`list-dot ${classNames(dot.size, {
        hidden: !dot.shown,
        selected: dot.selected,
      })}`}
    >
      <style jsx>
        {`
          .hidden {
            overflow: hidden; // Hide the element content, while height = 0
            height: 0;
            opacity: 0;
            transition: height 0ms ${TRANSITION_TIME}, opacity ${TRANSITION_TIME} 0ms;
          }

          .list-dot {
            height: auto;
            opacity: 1;

            transition: height ${TRANSITION_TIME} linear;
            transition: height 0ms 0ms, opacity ${TRANSITION_TIME} 0ms;

            background-color: white;
            opacity: 0.5;
            border-radius: 50%;
          }

          .large {
            width: 6px;
            height: 6px;
          }

          .medium {
            width: 4px;
            height: 4px;
          }

          .small {
            width: 2px;
            height: 2px;
          }

          .selected {
            opacity: 1;
          }
        `}
      </style>
    </li>
  );
}

export default function Dots({ className, count, currentSlide }: Props): JSX.Element {
  let centerOffset = 0;
  let pageOffset = 0;

  if (currentSlide - pageOffset <= 2) {
    centerOffset = currentSlide - pageOffset;
  } else {
    pageOffset = currentSlide - centerOffset - 1;
  }

  const dots = times(count, (index) => {
    const dot = new Dot({
      currentSlide,
      pageOffset,
      index,
    });

    return <ListDot dot={dot} key={index} />;
  });

  return (
    <ol className={classNames('dots', className)}>
      {dots}
      <style jsx>{`
        ol {
          list-style-type: none;
          flex-direction: row;
          display: flex;
          align-items: stretch; /* Default */
          justify-content: space-between;
          width: 60px;
          padding: 0;
          align-items: center;
        }
      `}</style>
    </ol>
  );
}
